<script setup lang="ts">
import { StackLayout } from '@/components/Layouts'
import type { ReplyModel } from '@/types/models/ReplyModel'
import { isDocumentPdf, truncateFileName } from '@/utils/fileUtils'
import EditButton from '../Buttons/EditButton.vue'
import { TypographyItem } from '../Typography'

type Props = {
    reply: ReplyModel
    isMyMessage: boolean
}

defineProps<Props>()
defineEmits<{
    (e: 'openPdf', pdfLink: string): void
    (e: 'openImage', imageSrc: string): void
}>()
</script>

<template>
    <StackLayout :class="isMyMessage ? 'align-self-end' : 'align-self-start '">
        <StackLayout
            direction="column"
            class="padding background-color border-radius"
            :class="isMyMessage ? 'align-self-end ' : 'align-self-start'"
            :style="{
                background: isMyMessage ? '' : 'linear-gradient(-45deg, #ff9532 0%, #fd5b00 100%)'
            }">
            <StackLayout
                :class="isMyMessage ? ' end-text justify-end ' : 'align-self-start'"
                class="padding border-radius text-pretty inline">
                <TypographyItem
                    class="title is-6"
                    :style="{ color: isMyMessage ? 'color-text' : 'white' }"
                    bold />
            </StackLayout>

            <TypographyItem
                class="padding text-pretty overflow-anywhere"
                :style="{ color: isMyMessage ? 'color-text' : 'white' }"
                :label="reply.message" />
            <StackLayout direction="column" v-if="reply.documents && reply.documents.length > 0">
                {{ $t('technician.ticket.message.attachment') }}
                <StackLayout
                    v-for="(document, index) in reply.documents"
                    :key="index"
                    class="flex-wrap"
                    style="padding: 1px">
                    <EditButton
                        v-if="isDocumentPdf(document.name)"
                        @click="$emit('openPdf', document.path)"
                        is-responsive
                        icon="file-pdf"
                        :label="truncateFileName(document.name)" />
                    <img
                        v-else
                        class="icon-img primary-border border-radius cursor-pointer"
                        @click="$emit('openImage', document.path)"
                        :src="document.path" />
                </StackLayout>
            </StackLayout>
        </StackLayout>
    </StackLayout>
</template>
